import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { FaEnvelope, FaEye, FaEyeSlash } from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";

const LoginScreen = () => {
  const [showPassword, setShowPassword] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();


  const location = useLocation();
  const [loginMessage, setLoginMessage] = useState(location.state?.loginMessage || "");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (location.state?.loginMessage) {
      setTimeout(() => setLoginMessage(""), 2000);
    }
  }, [location.state]);

  const onSubmit = async (data) => {
    setLoading(true);
    setLoginMessage("");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/buyers/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: data.email, password: data.password }),
        credentials: "include"
      });
      const resData = await response.json();
      setLoginMessage(resData.message);
      setLoading(false);
      setTimeout(() => setLoginMessage(""), 2000);
      if (resData.success && resData.token) {
        localStorage.removeItem("userToken");
        localStorage.setItem("userToken", resData.token);
        const buyerFullName =
          resData?.buyer?.fullName || resData?.data?.fullName;
        const buyerEmail =
          resData?.buyer?.email || resData?.data?.email || data.email;
        if (buyerFullName) {
          localStorage.setItem("buyerFullName", buyerFullName);
        }
        if (buyerEmail) {
          localStorage.setItem("buyerEmail", buyerEmail);
        }
        setTimeout(() => {
          navigate("/home", { state: { loginSuccess: resData.message } });
        }, 500); // short delay for message to show before redirect
      } else if (resData.success) {
        setTimeout(() => {
          navigate("/home", { state: { loginSuccess: resData.message } });
        }, 500);
      }
    } catch (err) {
      setLoginMessage("An error occurred. Please try again.");
      setLoading(false);
      setTimeout(() => setLoginMessage(""), 2000);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-white">
      <div className="w-full max-w-md">
        {loginMessage && (
          <div style={{ background: '#A3E7C1', color: '#000', padding: '12px 24px', borderRadius: '8px', marginBottom: '16px', fontWeight: 500, textAlign: 'center' }}>
            {loginMessage}
          </div>
        )}
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="space-y-6 text-left"
          noValidate
        >
          <div className="text-center">
            <img
              src="/BUY%20iT%20Logo.png"
              alt="BUY iT logo"
              className="mx-auto mb-3 h-[64px] w-[53px] object-contain"
            />
            <h1 className="text-2xl font-bold">Welcome to BUY iT</h1>
            <p className="text-gray-500">Login to continue</p>
          </div>

          <div className="space-y-4">
            <div>
              <label
                htmlFor="email"
                className="block text-left text-sm font-medium text-gray-700"
              >
                Email address
              </label>
              <div className="mt-1 relative rounded-md shadow-sm">
                <div className="pointer-events-none absolute inset-y-0 right-0 pr-3 flex items-center">
                  <FaEnvelope className="h-4 w-4 text-gray-400" />
                </div>
                <input
                  id="email"
                  type="email"
                  placeholder="Enter your email"
                  className="block w-full rounded-md border border-gray-300 pl-3 pr-10 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-[#19C463] focus:border-[#19C463] sm:text-sm"
                  aria-invalid={errors.email ? "true" : "false"}
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Enter a valid email",
                    },
                  })}
                />
              </div>
              {errors.email && (
                <p className="mt-1 text-sm text-red-600" role="alert">
                  {errors.email.message}
                </p>
              )}
            </div>

            <div>
              <label
                htmlFor="password"
                className="block text-left text-sm font-medium text-gray-700"
              >
                Password
              </label>
              <div className="mt-1 relative rounded-md shadow-sm">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  className="block w-full rounded-md border border-gray-300 pl-3 pr-10 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-[#19C463] focus:border-[#19C463] sm:text-sm"
                  aria-invalid={errors.password ? "true" : "false"}
                  {...register("password", {
                    required: "Password is required",
                  })}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}
                  className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 z-10"
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? (
                    <FaEyeSlash className="h-4 w-4" />
                  ) : (
                    <FaEye className="h-4 w-4" />
                  )}
                </button>
              </div>
              {errors.password && (
                <p className="mt-1 text-sm text-red-600" role="alert">
                  {errors.password.message}
                </p>
              )}
            </div>
          </div>

          <button
            type="submit"
            className="w-full flex justify-center py-3 px-4 rounded-md bg-[#19C463] text-white text-sm font-medium shadow-sm hover:bg-[#19C463] focus:outline-none focus:ring-2 focus:ring-[#19C463] focus:ring-offset-2"
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </button>

          <div className="text-center text-sm font-medium text-[#19C463]">
            <Link to="/signup" className="hover:underline">
              New user? Sign Up
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginScreen;
